<template>
  <div class="protocol2-container">
    <h4 class="title">
      <van-nav-bar title="授权协议" left-text="返回" left-arrow @click-left="back" />
    </h4>
    <div class="content">
      <h5>一、协议主体</h5>
      <p>服务接受方，即星火南通信息服务公众服务平台用户（个人或企业），包含注册用户和非注册用户。</p>
      <p>服务提供方，即星火（南通）信息服务有限公司及关联机构运营服务的星火南通信息服务公众服务平台（以下简称"星火南通信息服务平台"）。</p>
      <h5>二、缔约前提示</h5>
      <p>1. 请您在使用星火南通信息服务平台服务前认真阅读、充分理解全部协议内容。</p>
      <p>特别是其中所涉及的免除及限制星火南通信息服务平台责任的条款、对用户权利限制的条款等。</p>
      <p>请您审慎阅读并自愿选择接受或不接受本协议。如您对协议有任何疑问，可向星火南通信息服务平台咨询。若您一旦注册或使用星火南通信息服务平台，则视为您已充分理解并完全接受本协议的全部条款，并无条件地、不可撤销地同意接受星火南通信息服务平台的服务，受以下全部条款的约束。如有违反本协议条款而导致任何法律后果，您将独立承担所有相应的法律责任。若您不接受以下条款，请您立即停止注册或停止使用星火南通信息服务平台的服务。</p>
      <p>2. 对于您提供的所有资料及数据信息，一经注册视为您无条件地、不可撤销地在账号使用期内授予星火南通信息服务平台全球通用的、免费的使用权利。</p>
      <p>3. 本协议内容包括但不限于协议正文及所有星火南通信息服务平台已经发布的或将来可能发布以及可能不时修订的各类规则。所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。除另行明确声明外，星火南通信息服务平台提供的任何服务均受本协议约束。</p>
      <p>4. 星火南通信息服务平台有权根据需要适时的修改本协议及或各类规则，并在星火南通信息服务平台上公示，如您不同意相关变更，请停止使用星火南通信息服务平台服务。如您继续使用星火南通信息服务平台服务，即表示您无条件、不可撤销地理解并接受新修订的协议和规则。如新旧规则或协议之间冲突或矛盾的，除另行明确声明外，以最新修订的协议和规则为准。</p>
      <p>5. 星火南通信息服务平台是遵循国家相关法律法规设立，旨在帮助中小微纳税企业及个人解决融资难的问题而设立的官方服务平台。星火南通信息服务平台遵循自愿服务原则、数据保密原则、公众服务原则。自愿服务原则是注册用户根据自身需要自愿选择星火南通信息服务平台的服务。数据保密原则是税务机关依据国家税收征管法保护纳税人数据安全，银行依据银行业保密规定为客户数据进行保密，星火南通信息服务平台依据征信业管理条例为注册用户的数据保密。公众服务原则是星火南通信息服务平台为具有融资需求的中小微企业提供融资信息渠道，服务大众。</p>
      <p>6. 用户须在星火南通信息服务平台以实名制注册并根据星火南通信息服务平台的要求提供用户自身相关信息，包括但不限于公司名称、联系人、联络信息、工商注册信息、税务登记信息、企业财务信息及资金的需求描述和说明等。用户需遵循星火南通信息服务平台所使用的数据采集方式并对自身提供的信息真实性、完整性、准确性承担全部责任。若您填写的信息不完整，将直接影响星火南通信息服务平台对您资信的分析。用户应结合自身的财务状况、风险承受能力、风险识别能力等谨慎选择适用由星火南通信息服务平台合作银行提供的金融服务产品，并自行承担因此产生的法律后果。星火南通信息服务平台只提供用户以及合作银行金融服务产品的相关信息，对用户提供信息的真实性、准确性和完整性不作任何实质性审核和确认，不承担任何法律责任。</p>
      <p>7. 凡通过星火南通信息服务平台及其链接的其它网站而获得的网上资料及内容，仅供您浏览和参考之用，请您结合自身融资需求及资信状况对相关内容自行辨别及判断，星火南通信息服务平台对上述资料及内容不承担任何责任。</p>
      <p>8. 互联网传输可能会受到干扰、中断、延迟、数据错误、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为、网络服务平台或相关设备的定期或者不定期检修、维护，非星火南通信息服务平台能控制的通讯设施、硬件故障引致的数据及交易的不准确、不及时或者服务中断，星火南通信息服务平台均不承担任何责任。</p>
      <p>9. 星火南通信息服务平台提供服务过程中涉及的所有内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权归星火南通信息服务平台所有，用户在使用本服务中所产生的内容的知识产权归用户或相关权利人所有。除另有特别声明外，星火南通信息服务平台提供本服务时所依托软件的著作权、专利权及其他知识产权均归星火南通信息服务平台所有。上述及其他任何本服务包含的内容的知识产权均受到法律保护，未经星火南通信息服务平台、用户或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。</p>
      <h5>三、 用户的承诺和保证</h5>
      <p>星火南通信息服务数科一直以来坚守合规经营，对任何违法行为零容忍！作为中国智能金融生态领跑者，一直以来积极响应国家普惠金融的号召，严守合规经营与合规宣传底线，加强平台用户合规展业，杜绝任何违规行为发生，且一直保留对任何违规行为进行追责起诉权利！</p>
      <p>星火南通信息服务数科不允许任何人员冒用平台或平台合作方名义进行虚假宣传、以任何形式向客户收取包括但不限于居间服务费、咨询费、手续费等额外费用，更不允许以各种形式侵害客户借款或财务。一旦发现用户违规，平台有权采取相关手段进行追责。如用户构成诈骗行为的，本平台将通过报警等手段维护客户和平台的正当权益。</p>
      <p>请广大用户提高警惕，如有任何疑问，请通过官方信息渠道与我司进行联系确认与举报。</p>
      <p>1. 在您进行用户的注册时，您已是中国籍年满18周岁且具有完全民事行为能力的自然人或已经在工商行政管理局登记注册依法设立并有效存续的企业法人。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果，且星火南通信息服务平台有权不经通知直接注销您的帐号（登录名）。</p>
      <p>2. 在您签署本协议，申请星火南通信息服务平台上唯一的用户名，完成注册程序后，请妥善保存星火南通信息服务平台账号、密码等，用户应对帐号和密码的安全负责，如发现帐号存在异常，请及时与星火南通信息服务平台联系。任何通过您的用户名和密码实施的行为将视为您个人或您的企业的行为，无论是您自己操作还是其他人操作，都由您承担全部责任，星火南通信息服务平台不承担任何责任。在未征得星火南通信息服务平台同意的前提下，您不得以任何方式转让、赠与星火南通信息服务平台的用户名和密码。</p>
      <p>3. 在接受星火南通信息服务平台服务的过程中，用户无条件、不可撤销地承诺不从事下列行为：</p>
      <p>（1） 发表、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、暴力以及任何违反国家法律法规的内容；</p>
      <p>（2） 发表、传送、传播、储存侵害他人知识产权、商业秘密等合法权益的内容；</p>
      <p>（3） 制造虚假身份、隐瞒真相、发布虚假信息等误导、欺骗他人，或违背星火南通信息服务平台公布之规则进行虚假交易；</p>
      <p>（4） 进行危害计算机网络安全的行为；</p>
      <p>（5） 其他违法、违规行为。</p>
      <p>4. 在星火南通信息服务平台使用服务过程中，用户无条件、不可撤销地承诺遵守以下约定：</p>
      <p>（1） 在使用星火南通信息服务平台过程中实施的所有行为均遵守国家法律、法规及星火南通信息服务平台的各项规则，不违背社会公共利益或公共道德，不损害他人的合法权益。</p>
      <p>（2） 不发布国家禁止发布的信息，不发布其它涉嫌违法或违反本协议及各类规则的信息等。</p>
      <p>（3） 不对星火南通信息服务平台上的任何数据作商业性利用，包括但不限于在未经星火南通信息服务平台事先书面同意的情况下，以复制、传播等任何方式使用星火南通信息服务平台上展示的资料。</p>
      <p>5. 用户无条件、不可撤销地同意并授权：</p>
      <p>（1） 如违反上述承诺时，星火南通信息服务平台有权依据本协议的约定，做出相应处理或终止向您提供服务，且无须征得您的同意或提前通知您。</p>
      <p>（2） 当您的行为涉嫌违反法律法规或违反本协议和/或规则的，星火南通信息服务平台有权采取相应措施，包括但不限于直接屏蔽、删除侵权信息，或直接停止提供服务。如您行为使星火南通信息服务平台遭受任何损失的（包括但不限于受到第三方的索赔、受到行政管理部门的处罚等），您还应当赔偿或补偿星火南通信息服务平台遭受的全部损失及(或)发生的全部费用，包括但不限于诉讼费、律师费、保全费、公证费等。</p>
      <p>6. 用户自愿接收国家税务局、银行和星火南通信息服务平台联合提供的持续短信通知服务（短信通知的内容包括但不限于用户的预授信额度总额及余额）。如对用户的日常经营造成影响的，用户可自行通过短信方式取消订阅。用户无条件、不可撤销地承诺不得因此向国家税务局、银行和星火南通信息服务平台投诉或主张任何补偿。</p>
      <h5>四、 其他</h5>
      <p>1. 本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律（香港特别行政区、澳门特别行政区、台湾地区除外），如无相关法律规定，可参照商业惯例和（或）行业习惯。</p>
      <p>2. 因本协议产生的争议，应当协商解决，协商不成可向星火（南通）信息服务有限公司及关联机构所在地有管辖权的人民法院起诉。</p>
      <p>3. 星火南通信息服务平台保留对本协议及所有规则的最终解释权。</p>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    back() {
      this.$router.back()
    }
  }
}
</script>
<style lang="less">
.protocol2-container {
  background: #fff;
  padding: 0 10px 10px;

  .content {
    padding-top: 50px;
  }

  .title {
    font-size: 20px;
    line-height: 40px;
    text-align: center;
    position: fixed;
    left: 0;
    right: 0;
    background: #fff;
    border-bottom: 1px solid #eee;

    .icon {
      line-height: 80px;
      position: absolute;
      left: 10px;
    }
  }

  p {
    font-size: 15px;
    text-indent: 2em;
    line-height: 22px;

    &.tip {
      font-weight: bold;
    }
  }

  h5 {
    font-size: 20px;
    text-indent: 1.5em;
    margin-top: 5;
  }
}
</style>
